import React, { useState } from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps.js";
import Image from "../elements/Image.js";
import Modal from "../elements/Modal.js";
import HeaderBack from "../layout/HeaderBack.js";

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const PreviousHero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  };

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames(
    "display: inline-block",
    "flex-wrap: wrap",
    "tiles-wrap center-content",
    "border-style: solid",
    pushLeft && "push-left"
  );

  const divStyle = {
    margin: "0 auto",
    width: "355px",
  };

  return (
    <section {...props} className={outerClasses}>
      <HeaderBack />
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1>
              <span className="text-color-primary">Eerdere Video's</span>
            </h1>

            <p>Interview met Alric van den Broek</p>
          </div>

          {
            // Old Videos
          }
          <a
            data-video={require("./../../assets/video/AlricvandenBroek.MP4")}
            href="#0"
            aria-controls="video-modal"
            onClick={openModal}
          >
            <Image
              className="has-shadow"
              src={require("./../../assets/images/AlricvandenBroek.png")}
              alt="Hero"
              width={896}
              height={504}
            />
          </a>
        </div>
        <Modal
          id="video-modal"
          show={videoModalActive}
          handleClose={closeModal}
          video={require("./../../assets/video/AlricvandenBroek.MP4")}
          videoTag="iframe"
        />

        <br />
        <div>
          <div className={tilesClasses} style={divStyle}>
            <a style={{ width: "50%" }} href="https://taalunie.org/">
              <Image
                src={require("./../../assets/images/Nederlandse_Taalunie.jpeg")}
                alt="Open"
                width={100}
                height={52}
              />
            </a>{" "}
            <Image
              src={require("./../../assets/images/Nederlandse_Taalunie.jpeg")}
              alt="Open"
              width={0}
              height={0}
            />
            <a style={{ width: "50%" }} href="http://mediterraned.org/">
              <Image
                src={require("./../../assets/images/Mediterraned.png")}
                alt="Open"
                width={100}
                height={52}
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

PreviousHero.propTypes = propTypes;
PreviousHero.defaultProps = defaultProps;

export default PreviousHero;
